import { UserManagement } from "@/components/admin/UserManagement";

export const AdminUsers = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">User Management</h1>
        <p className="text-muted-foreground">Approve, reject, and manage user accounts</p>
      </div>
      
      <UserManagement />
    </div>
  );
};
